import { render, staticRenderFns } from "./Depot.vue?vue&type=template&id=5c1518f0&scoped=true&"
import script from "./Depot.vue?vue&type=script&lang=js&"
export * from "./Depot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1518f0",
  null
  
)

export default component.exports